module.exports = __webpack_public_path__ + "img/TPG-01.d7de5f1a.png";